import compact from 'lodash/compact'
import {
  JourneyGroupingFragment,
  JourneyMilestoneGroupingFragment,
  JourneySubmilestoneGroupingFragment,
  JourneyGroupGroupingFragment,
} from 'gatsby-graphql-types-generated'
import {graphql} from 'gatsby'

export const query = graphql`
  fragment JourneyTileGrouping on ContentfulJourneyTile {
    __typename
    id
  }

  fragment JourneyMilestoneGrouping on ContentfulMilestone {
    __typename
    id
    journeyAnswer {
      id
    }
    articleCount
    contentfulchildren {
      ...JourneyTileGrouping
      ...JourneySubmilestoneGrouping
    }
  }

  fragment JourneySubmilestoneGrouping on ContentfulSubmilestone {
    __typename
    journeyAnswer {
      id
    }
    id
    contentfulchildren {
      ...JourneyTileGrouping
    }
  }

  fragment JourneyGroupGrouping on ContentfulGroup {
    __typename
    journeyAnswer {
      id
    }
    id
    contentfulchildren {
      ...JourneyTileGrouping
    }
  }

  fragment JourneyGrouping on ContentfulJourney {
    id
    __typename
    contentfulchildren {
      ...JourneyTileGrouping
      ...JourneyMilestoneGrouping
      ...JourneyGroupGrouping
    }
  }
`

type ContentGrouping =
  | JourneyGroupingFragment
  | JourneyMilestoneGroupingFragment
  | JourneyGroupGroupingFragment
  | JourneyMilestoneGroupingFragment
  | JourneySubmilestoneGroupingFragment

const filterChildren = (
  grouping: ContentGrouping,
  answer?: string
): ContentGrouping & {articleCount: number} => {
  const filteredChildren = grouping.contentfulchildren || []
  const newChildren = compact(
    [...filteredChildren].map((c: any) => {
      switch (c.__typename) {
        case 'ContentfulGroup':
          return c.journeyAnswer?.id === answer ||
            c.journeyAnswer?.id === null ||
            c.journeyAnswer?.id === undefined
            ? filterChildren(c, answer)
            : null
        case 'ContentfulMilestone':
          return c.journeyAnswer?.id === answer ||
            c.journeyAnswer?.id === null ||
            c.journeyAnswer?.id === undefined
            ? filterChildren(c, answer)
            : null
        case 'ContentfulSubmilestone':
          return c.journeyAnswer?.id === answer ||
            c.journeyAnswer?.id === null ||
            c.journeyAnswer?.id === undefined
            ? filterChildren(c, answer)
            : null
        case 'ContentfulJourneyTile':
          return c
        default:
          throw new Error('Unknown __typename')
      }
    })
  )

  const newArticleCount = newChildren.reduce<number>((acc, c) => {
    return c.__typename === 'ContentfulJourneyTile'
      ? acc + 1
      : acc + c.articleCount
  }, 0)

  return {
    ...grouping,
    articleCount: newArticleCount,
    contentfulchildren: newChildren,
  }
}

export const usePersonalizationFilter = <
  T extends JourneyGroupingFragment | JourneyMilestoneGroupingFragment
>(
  journey: T,
  studentJourney?: string
): T => {
  if (studentJourney === null || studentJourney === undefined) {
    return journey
  }

  return filterChildren(journey, studentJourney) as any
}

export default usePersonalizationFilter
